import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import {useTranslation} from 'react-i18next';
import React, {memo} from 'react';
import styled from 'styled-components';
import {MinWidthButtonWrapper} from '../util/StyledElements';

const EmptyState = styled.div`
   height: 15rem;
   display: flex;
   align-items: center;
   justify-content: center;
   flex-direction: column;
   span {
     font-weight: 600;
   }
   button {
      margin-top: 1rem;
   }
`;

export const ShareToCollectionEmptyStateBase: React.FC<IShareToCollectionEmptyStateProps> = ({onCreateCollection}) => {
   const {t} = useTranslation();

   return (
      <EmptyState>
         <span>
            {t('collections.none')}
         </span>
         <MinWidthButtonWrapper>
            <ControlButton
               label={t('collections.create.new')}
               buttonType={TscButtonType.primary}
               onClick={onCreateCollection}
               testId="create-collection-button"
            />
         </MinWidthButtonWrapper>
      </EmptyState>
   );
};

export interface IShareToCollectionEmptyStateProps {
   onCreateCollection(): void;
}

export default memo(ShareToCollectionEmptyStateBase);
